import { IAvatar } from "interfaces/IAvatar";
import { atom } from "recoil";

export const avatarState = atom({
    key: 'avatar',
    default:{
        id:null
    } as IAvatar,
  });